<!--
  name : 김혜진
  desc : 
  date : 2020-07-29
-->
<template>
  <v-container class="con_mpw">
    <div id="verify">
      <!--1. 검증전-->
      <v-row
        no-gutters
        class="file_inP_box justify-center pt-10 pb-10"
        v-if="vStep01"
      >
        <!--드래그&드랍-->
        <v-col cols="12" align="center">
          <span class="icon verify off"></span>
          <v-row no-gutters class="row_mt-20 justify-center">
            <v-col cols="12" sm="8">
              <v-file-input
                class="inputH48_01 W100W Hauto inputSt_file"
                outlined
                dense
                label="검증할 계약서 파일"
                placeholder="여기를 눌러 검증할 계약서 파일을 올려주세요"
                v-model="verifyFile"
                :accept="uploadCtrPaperAccept"
                @change="changeInput()"
              ></v-file-input>
            </v-col>
          </v-row>
          <div class="file_inP_dorp_txtBox mb-10">
            <span>검증할 계약서 파일을 올려주세요.</span>
            <span class="file_inP_dorp_txt02">(PDF파일만 올려주세요.)</span>
          </div>
        </v-col>
      </v-row>

      <v-row
        no-gutters
        class="file_inP_box justify-center pt-10 pb-10"
        v-if="vStep02"
      >
        <!--드래그&드랍 후-->
        <span class="icon verify off"></span>
        <div class="file_inP_dorp_txtBox mb-10">
          <span class="file_inP_dorp_icon"></span>
          <div class="file_inP_dorp_iconTxt">{{ this.verifyFile.name }}</div>
        </div>
        <v-btn
          color="primary"
          outlined
          class="btnSt_line00 mb-10"
          @click="Initialization()"
          >초기화</v-btn
        >
      </v-row>

      <v-row
        no-gutters
        class="file_outP_box justify-center"
        v-if="vStep01 || vStep02"
      >
        글로싸인엔터프라이즈에서 발행한 정상적인 계약서를 업로드하면 해당
        계약서에 대한 정보가 보여집니다.
      </v-row>

      <!--2. 검증후-->
      <v-row
        no-gutters
        class="verify_box justify-center pt-10 pb-10"
        v-if="vStep03"
      >
        <!-- success -->
        <span class="icon verify"></span>
        <div class="file_inP_dorp_txtBox mb-10">
          <span
            >글로싸인엔터프라이즈에서 체결한
            <strong style="color:#40bfda;">신뢰할 수 있는 계약서</strong
            >입니다.</span
          ><br />
          <span
            >현재 계약서 상태는
            <strong
              v-if="this.contractStatus === '계약 요청 상태'"
              style="font-weight: bold;color:#4d82f4;"
              >{{ this.contractStatus }}</strong
            >
            <strong
              v-if="this.contractStatus === '계약 승인 상태'"
              style="font-weight: bold;color:#68c232;"
              >{{ this.contractStatus }}</strong
            >
            <strong
              v-if="this.contractStatus === '계약 거부 상태'"
              style="font-weight: bold;color:#ff7666;"
              >{{ this.contractStatus }}</strong
            >
            <strong
              v-if="this.contractStatus === '계약 요청 취소 상태'"
              style="font-weight: bold;color:#9da09f;"
              >{{ this.contractStatus }}</strong
            >
            입니다.</span
          >
        </div>

        <v-col
          cols="12"
          class="verifyBox_part"
          v-for="(contracts, index) of contracts"
          :key="index"
        >
          <v-row no-gutters class="Box_part_tt align-center">
            <div class="carD_chip00">
              <v-chip
                class="st02"
                v-if="contracts.contractStatus === '계약 요청'"
                >{{ contracts.contractStatus }}</v-chip
              >
              <v-chip
                class="st04"
                v-if="contracts.contractStatus === '계약 거부'"
                >{{ contracts.contractStatus }}</v-chip
              >
              <v-chip
                class="st05"
                v-if="contracts.contractStatus === '계약 승인'"
                >{{ contracts.contractStatus }}</v-chip
              >
              <v-chip
                class=""
                v-if="contracts.contractStatus === '계약 요청 취소'"
                >{{ contracts.contractStatus }}</v-chip
              >
            </div>
            <div class="st_tt">
              <!--계약명-->
              <span class="st_tt_01">{{ verifyFile.name }}</span>
            </div>
          </v-row>

          <v-row no-gutters class="Box_part_txt">
            <v-col cols="12">
              <ul class="pattern_ulTxtBox">
                <li>
                  <span class="txt_icon">요청</span>
                  <span class="txt_txt01 no_pr">{{
                    contracts.senderName
                  }}</span>
                </li>
                <li v-if="contracts.senderBrokerName">
                  <span class="txt_icon">요청대행</span>
                  <span class="txt_txt01 no_pr">{{
                    contracts.senderBrokerName
                  }}</span>
                </li>
                <li>
                  <span class="txt_icon">수신</span>
                  <span class="txt_txt01 no_pr">{{
                    contracts.receiverName
                  }}</span>
                </li>
                <li v-if="contracts.receiverBrokerName">
                  <span class="txt_icon">수신대행</span>
                  <span class="txt_txt01 no_pr">{{
                    contracts.receiverBrokerName
                  }}</span>
                </li>
              </ul>
            </v-col>

            <v-col cols="12">
              <ul class="pattern_ulTxtBox">
                <li>
                  <span class="txt_tt02">[트랜잭션 ID]</span>
                  <span class="txt_txt01 no_pr">{{
                    contracts.transactionId
                  }}</span>
                </li>
                <li>
                  <span class="txt_tt02"
                    >[{{ contracts.contractStatus }}일시]</span
                  >
                  <span class="txt_txt01">{{ contracts.updatedDatetime }}</span>
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row
        no-gutters
        class="verify_box justify-center pt-10 pb-10"
        v-if="vStep04"
      >
        <!-- fail -->
        <span class="icon verify no"></span>
        <div class="file_inP_dorp_txtBox mb-10">
          <span
            >글로싸인엔터프라이즈에서 체결하지 않은
            <font class="fc_C05">신뢰할 수 없는 계약서</font
            >입니다.<br />계약서원본이 아닌 인쇄본(스캔)은 검증되지
            않습니다.</span
          >
          <div>{{ this.result }}</div>
        </div>
      </v-row>

      <v-row
        no-gutters
        class="stepFOut_boTcon align-center justify-center"
        v-if="!vStep01"
      >
        <v-btn
          class="btn19_C01"
          @click="
            hidden = !hidden;
            clickBtn(hidden);
          "
        >
          {{ hidden ? "재검증하기" : "검증하기" }}
        </v-btn>
      </v-row>

      <s-confirm ref="confirm"></s-confirm>
      <s-loading ref="loading"></s-loading>
    </div>
  </v-container>
</template>
<script>
import { verifyContract } from "@/api/contract/verifyContract";

export default {
  name: "verify",
  components: {},
  filters: {
    regNumFilter: function(value) {
      if (value) {
        return String(value).replace(/(\d{3})(\d{2})(\d{5})/, "$1-$2-$3");
      }
    }
  },
  data() {
    return {
      hidden: false,
      vStep01: true,
      vStep02: false,
      vStep03: false,
      vStep04: false,
      verifyFile: "",
      uploadCtrPaperAccept: ".pdf",

      result: null,
      contracts: null,
      contractStatus: false
    };
  },
  created() {},
  mounted() {},
  methods: {
    changeInput() {
      if (this.verifyFile) {
        this.vStep01 = false;
        this.vStep02 = true;
      }
    },

    Initialization() {
      this.vStep01 = true;
      this.vStep02 = false;
      this.vStep03 = false;
      this.vStep04 = false;
      this.verifyFile = "";
    },

    clickBtn(hidden) {
      if (hidden) {
        this.checkVerifyFile();
      } else {
        this.vStep01 = true;
        this.vStep02 = false;
        this.vStep03 = false;
        this.vStep04 = false;
        this.verifyFile = "";
      }
    },

    // 계약서 파일 검증
    checkVerifyFile() {
      this.$refs.loading.start("신뢰할 수 있는 계약서 파일인지 검증 중입니다.");

      const data = new FormData();
      data.append("file", this.verifyFile);

      verifyContract(data)
        .then(response => {
          this.vStep02 = false;
          if (response.rdata.rcode === 20000) {
            this.contracts = response.rdata.contracts;
            this.contractStatus = response.rdata.contractStatus;

            if (response.rdata.isQRCode) {
              if (response.rdata.isContract) {
                if (response.rdata.compareFileHash) {
                  // success
                  this.vStep03 = true;
                } else {
                  // fail
                  this.vStep04 = true;
                  if (response.rdata.contractStatus) {
                    this.result =
                      '<strong style="color:red; font-size: 15px; !important;">신뢰할 수 없는 계약서</strong>입니다. <br/><br/><strong style="font-size: 15px;">변조된 계약서이거나 상태가 변경된 계약서</strong>이므로 사이트에서 계약서 상태가 변경(승인, 거부, 취소 등등..)이 되었는지 확인한 뒤, <br/><br/>변경이 되었으면 다시 변경된 계약서를 다운로드 받아주시기 바랍니다. <br/><br/>만약 이 계약서가 정상적인 계약서라면, 글로싸인엔터프라이즈 관리자에게 문의해주세요.';
                  } else {
                    this.result =
                      "블록체인 통신 에러입니다. 글로싸인엔터프라이즈 관리자에게 문의해주세요.";
                  }
                }
              } else {
                // fail
                this.vStep04 = true;
                this.result =
                  '업로드한 계약서의 계약 번호에 <strong style="color:red; font-size: 15px; !important;">해당하는 계약서가 존재하지 않습니다.</strong>';
              }
            } else {
              // fail
              this.vStep04 = true;
              this.result =
                '업로드한 PDF에는 <strong style="color:red; font-size: 15px; !important;">QR코드가 존재하지 않습니다.</strong>';
            }
          } else {
            // fail
            this.vStep04 = true;
            this.result = response.rdata.message;
          }
          this.$refs.loading.end();
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>
<style>
.inputSt_file .v-input__append-inner {
  margin-top: 11px;
}
</style>
